import { useState, useEffect, useRef } from "react";
import LoadingFluxi from "../components/common/LoadingFluxi/LoadingFluxi";
import { useAuth } from "../context/AuthContext";
import { getTemplateWebsite } from "../services/s3TemplateWebsites/s3TemplateWebsites";

const WebsiteBuilderIframePage = () => {
  const [loading, setLoading] = useState(true);
  
  // cambia esto a un ref
  const contentPageRef = useRef({});
  // const [contentPage, setContentPage] = useState({});

  useEffect(() => {

    const websiteUuid = window.location.pathname.split("/").pop() || "";
    const data = {
      schema_partition: `/websites/id=${websiteUuid}/v1`,
    };
    getTemplateWebsite(data)
      .then((response) => {
        // if (data.status === 200) {
        // setLastCopys(data);
        setLoading(false);
        // }
        contentPageRef.current = response.data;
      })
      .catch((error) => {
        console.error("Error fetching last copy by user id: ", error);
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F6FA] font-['Plus_Jakarta_Sans']">
      {loading ? (
        <LoadingFluxi />
      ) : (
        <></>
      )}
    </div>
  );
};

export default WebsiteBuilderIframePage;
